// extracted by mini-css-extract-plugin
export default {"rating":"sz-z","numberOfStars":"tz-z","count":"uz-z","barGraphSpacing":"vz-z","barGraph":"wz-z"};